import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, withStyles, Typography, ListItemText, FormControlLabel, Checkbox } from '@material-ui/core';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from 'react-i18next';
import { faLongArrowLeft, faLongArrowRight } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx'
import CustomToolTip from '../../UI/ToolTip/ToolTip';
import cloneDeep from 'lodash/cloneDeep';
import { objectSize } from '../../../../common/utilities/utilitiesFunctions';
import { List as VirtualList } from 'react-virtualized';

const styles = theme => ({
	dualbox: {
		display: 'flex',
		textAlign: 'right',
		paddingBottom: '5px',
		marginTop: '7px',
		position: 'relative',
	},
	boxWrapper: {
		position: 'relative',
		width: '100%',
	},
	root: {
		width: '100%',
		backgroundColor: theme.palette.background.paper,
		position: 'relative',
		overflow: 'hidden',
		border: '2px outset #6ea0d7',
		height: 220,
		borderRadius: '5px'
	},
	header: {
		padding: '5px 5%',
		color: 'rgba(0, 0, 0, 0.54)',
		fontSize: '15px',
		zIndex: 1,
		width: '100%',
		height: 40,
		backgroundColor: '#FFFFFF',
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	boxList: {
		overflow: 'auto',
		height: 180,
	},
	icons: {
		alignSelf: 'center',
		padding: '10px',
		fontSize: 'x-large',
		color: '#6ea0d7',
	},
	listItems: {
		borderBottom: '1px solid #e6edf5',
		'&:hover': {
			backgroundColor: '#e6edf5',
		}
	},
	subHeader: {
		color: '#878787',
		flex: 1
	},
	containerLabels: {
		display: 'flex',
		width: '90%'
	},
	inputCheckbox: {
		display: 'inline-block'
	},
	selectAll: {
		position: 'absolute',
		left: 16
	},
	icon: {
		marginLeft: 'auto',
	},
	iconSelected: {
		color: '#6EA0D7'
	},
	iconDeselected: {
		color: '#DCDCDC'
	}
});

class DualListBoxVirtualized extends Component {

	constructor(props) {
		super(props);
		this.state = {
			includedSEL: {},
			excludedSEL: {},
			keyIncluded: [],
			keyExcluded: [],
			keyIncludedDisplayed: [],
			keyExcludedDisplayed: [],
		}
	}

	SelectTarget = (data = [], target) => {
		for (const element of data) {
			element.target = target
		};
		return data
	}

	initObject = (data = []) => {
		let object = {};
		for (const element of data) {
			object[element.id] = cloneDeep(element)
		};
		return object
	}

	handleItem = (item, target, event) => {
		let auxList = {}
		auxList = cloneDeep(this.state[target])
		if (event.target.checked) {
			auxList[item.id] = item;
		} else {
			delete auxList[item.id]
		}
		this.setState({
			[target]: auxList
		})
	}

	allSelected = (list, target) => {
		return objectSize(this.state[list]) === this.props[target].length && this.props[target].length > 0
	}

	isChecked = (item, target) => {
		return this.state[target][item.id] === undefined ? false : true
	}

	handleSelectAll = (list, target, event) => {
		let result = {};
		if (event.target.checked) {
			result = this.initObject(this.props[target])
		}
		this.setState({
			[list]: result
		})
	}

	customButtonState = (item) => {
		const { classes, customBandName } = this.props
		let auxClass = typeof item.value[customBandName] === 'undefined' || !item.value[customBandName] ? classes.iconDeselected : classes.iconSelected;
		return clsx(classes.icon, auxClass)
	}

	handleCustomButtom = (item) => {
		const { dataSelected, updateIncluded, target, customFeature, customBandName } = this.props;
		if (customFeature) {
			let includedFinal = this.initObject(dataSelected);
			if (typeof includedFinal[item.id].value[customBandName] === 'undefined' || !includedFinal[item.id].value[customBandName]) {
				includedFinal[item.id].value[customBandName] = true;
			} else {
				includedFinal[item.id].value[customBandName] = false;
			}
			updateIncluded(target, includedFinal)
		}
	}

	handleMove = (target, direction) => {
		const { includedSEL, excludedSEL } = this.state;
		const { dataSelected, dataExcluded, moveSelectedAll, moveAll } = this.props;
		if (typeof moveSelectedAll !== 'undefined') {
			let includedFinal = this.initObject(dataSelected);
			let excludedFinal = this.initObject(dataExcluded);
			if (direction === 'toLeft') {
				for (let item in includedSEL) {
					delete includedFinal[item]
					excludedFinal[item] = includedSEL[item];
				}
				this.setState({
					excludedSEL: {},
					keyExcluded: [],
				})
			} else {
				for (let item in excludedSEL) {
					delete excludedFinal[item]
					includedFinal[item] = excludedSEL[item];
				}
				this.setState({
					includedSEL: {},
					keyIncluded: [],
				})
			}
			moveSelectedAll(target, includedFinal, excludedFinal)
		}
		if (typeof moveAll !== 'undefined') {
			moveAll(target, direction)
		}
	}

	isRowIncludedLoaded = ({ index }) => {
		const { keyIncluded } = this.state;
		return !!keyIncluded[index];
	}

	isRowExcludedLoaded = ({ index }) => {
		const { dataExcluded } = this.state;
		return !!dataExcluded[index];
	}

	loadMoreIncludedRows = ({ startIndex, stopIndex }) => {
		const { dataSelected } = this.props;

		let list = dataSelected.slice(startIndex, stopIndex);

		this.setState({ keyIncludedDisplayed: list });
	}

	loadMoreExcludedRows = ({ startIndex, stopIndex }) => {
		const { dataExcluded } = this.props;

		let list = dataExcluded.slice(startIndex, stopIndex);

		this.setState({ keyExcludedDisplayed: list });
	}

	renderRowExcluded = ({ key, index, style }) => {
		const { dataExcluded, selectableItem, classes } = this.props;
		const { keyExcluded } = this.state;

		let item = <FormControlLabel
			control={
				<Checkbox
					color={'primary'}
					checked={this.isChecked(dataExcluded[index], 'excludedSEL')}
					key={`item-${dataExcluded[index].value}-${keyExcluded}-CBI`}
					onClick={(event) => { this.handleItem(dataExcluded[index], 'excludedSEL', event) }}
					className={classes.inputCheckbox}
				/>}
			label={<ListItemText primary={`${dataExcluded[index].label}`} />}
		/>

		return (<div style={{ ...style, display: 'flex', paddingLeft: 16 }}>
			{
				selectableItem ?
					(dataExcluded[index].tooltip ? <CustomToolTip titletext={dataExcluded[index].tooltip} jsx={item} /> : item)
					: <ListItemText primary={`${dataExcluded[index].label}`} />
			}
		</div>
		)
	}

	renderRowIncluded = ({ key, index, style }) => {
		const { dataSelected, selectableItem, classes } = this.props;
		const { keyIncluded } = this.state;

		let item = <FormControlLabel
			control={
				<Checkbox
					color={'primary'}
					checked={this.isChecked(dataSelected[index], 'includedSEL')}
					key={`item-${dataSelected[index].value}-${keyIncluded}-CBI`}
					onClick={(event) => { this.handleItem(dataSelected[index], 'includedSEL', event) }}
					className={classes.inputCheckbox}
				/>}
			label={<ListItemText primary={`${dataSelected[index].label}`} />}
		/>

		return (<div style={{ ...style, display: 'flex', paddingLeft: 16 }}>
			{
				selectableItem ?
					(dataSelected[index].tooltip ? <CustomToolTip titletext={dataSelected[index].tooltip} jsx={item} /> : item)
					: <ListItemText primary={`${dataSelected[index].label}`} />
			}
		</div>
		)
	}

	noRowsRenderer() {
		return <div className={styles.noRows}>{this.props.t('Text.noData')}</div>;
	}

	render() {
		const {
			classes, t, dataSelected, dataExcluded, target, subHeader,
			rightBoxText = t('DualListBox.excluded'),
			leftBoxText = t('DualListBox.included'),
			moveAllToRightText = t('DualListBox.excludeAll'),
			moveAllToLeftText = t('DualListBox.includeAll'),
			selectableItem
		} = this.props;

		return (
			<React.Fragment >
				<div className={classes.containerLabels}>
					<Typography className={classes.subHeader} color="textSecondary">{subHeader}</Typography>
				</div>
				<Grid className={classes.dualbox}>
					<div className={clsx(classes.boxWrapper, classes.root)}>
						{selectableItem ?
							<FormControlLabel
								className={classes.selectAll}
								control={
									<Checkbox
										color={'primary'}
										disabled={dataExcluded.length === 0}
										checked={this.allSelected('excludedSEL', 'data')}
										onClick={(event) => { this.handleSelectAll('excludedSEL', 'data', event) }}
										className={classes.inputCheckbox}
									/>}
								label={<ListItemText primary={t('DualListBox.selectAll')} />}
							/> : ''}
						<Typography className={classes.header}>{leftBoxText}</Typography>
						{dataExcluded.length > 0 ?
							<VirtualList style={{ width: '100%' }}
								width={500}
								height={176}
								rowHeight={38}
								rowRenderer={this.renderRowExcluded}
								rowCount={dataExcluded.length}
								noRowsRenderer={this.noRowsRenderer}
								overscanRowCount={3}
							/>
							: ''}
					</div>
					<div className={classes.icons}>
						<CustomToolTip
							titletext={moveAllToLeftText}
							jsx={<div><FontAwesomeIcon icon={faLongArrowLeft} onClick={() => this.handleMove(target, 'toLeft')} /></div>}>
						</CustomToolTip>
						<CustomToolTip
							titletext={moveAllToRightText}
							jsx={<div><FontAwesomeIcon icon={faLongArrowRight} onClick={() => this.handleMove(target, 'toRight')} /></div>}>
						</CustomToolTip>
					</div>
					<div className={clsx(classes.boxWrapper, classes.root)}>
						{selectableItem ?
							<FormControlLabel
								className={classes.selectAll}
								control={
									<Checkbox
										color={'primary'}
										disabled={dataSelected.length === 0}
										checked={this.allSelected('includedSEL', 'dataSelected')}
										onClick={(event) => { this.handleSelectAll('includedSEL', 'dataSelected', event) }}
										className={classes.inputCheckbox}
									/>}
								label={<ListItemText primary={t('DualListBox.selectAll')} />}
							/> : ''}
						<Typography className={classes.header}>{rightBoxText}</Typography>
						{dataSelected.length > 0 ?
							<VirtualList style={{ width: '100%' }}
								width={500}
								height={176}
								rowHeight={38}
								rowRenderer={this.renderRowIncluded}
								rowCount={dataSelected.length}
								noRowsRenderer={this.noRowsRenderer}
								overscanRowCount={3}
							/>
							: ''}
					</div>
				</Grid>
			</React.Fragment >
		)
	}
}

DualListBoxVirtualized.propTypes = {
	classes: PropTypes.object.isRequired,
}

export default translate('common')(withStyles(styles)(DualListBoxVirtualized));